/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserApiToken, selectCurrentUserM11Use } from "../../slices/currentUser/currentUserSlice";
import {
  m11ReportContainerFoiChanged, m11ReportContainerResourceChanged,
  m11ReportSection10FoiChanged, m11ReportSection10ResourceChanged, selectM11ReportContainerFoi,
  selectM11ReportContainerResource, selectM11ReportSection10Foi, selectM11ReportSection10Resource,
  selectM11ResearchStudyResource
} from "../../slices/m11ReportAuthoringTool/m11ReportAuthoringToolSlice";
import { useEffect, useState, useImperativeHandle, forwardRef } from "react";
import jsonEquals from "../../functions/jsonEquals";
import getIdFromReference from "../../functions/getIdFromReference";
import loadResource from "../m11ReportFunctions/loadResource";
import TextDivEntry from "./TextDivEntry";
import saveM11Changes from "../../functions/saveM11ChangesAPI";
import { selectM11ResearchStudyFoi } from "../../slices/m11StepCount/m11StepCountSlice";
import { validateStep } from "../../functions/validateM11ReportAPI";

const saveStatisticsChanges = async (dispatch, apiToken, m11ResearchStudyFoi,
  section10State, setAlertModalState, setStartingSection10State) => {

  let changesStates = {
    section10State: section10State
  };
  let response = await saveM11Changes(apiToken, 33, m11ResearchStudyFoi, changesStates);
  if (response?.success) {
    if (response.m11ReportContainerResource) {
      dispatch(m11ReportContainerResourceChanged(response.m11ReportContainerResource));
    }
    if (response.m11ReportSection10Resource) {
      dispatch(m11ReportSection10ResourceChanged(response.m11ReportSection10Resource));
    }
    setStartingSection10State(JSON.parse(JSON.stringify(section10State)));
  } else {
    if (response.error) {
      alert(response.error);
    }
  }
};

const M11Step033StatisticsPart1 = forwardRef(({ theM11ResearchStudyFoi, setAlertModalState }, ref) => {

  const dispatch = useDispatch();
  const apiToken = useSelector(selectCurrentUserApiToken);
  const m11User = useSelector(selectCurrentUserM11Use);
  const m11ResearchStudyResource = useSelector(selectM11ResearchStudyResource);
  const m11ReportContainerFoi = useSelector(selectM11ReportContainerFoi);
  const m11ReportContainerResource = useSelector(selectM11ReportContainerResource);
  const m11ReportSection10Foi = useSelector(selectM11ReportSection10Foi);
  const m11ReportSection10Resource = useSelector(selectM11ReportSection10Resource);
  const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

  const [section10State, setSection10State] = useState({
    "section101Status": "empty", "section101Xhtml": "",
    "section102Status": "empty", "section102Xhtml": "",
    "section103Status": "empty", "section103Xhtml": ""
  });
  const [startingSection10State, setStartingSection10State] = useState({
    "section101Status": "empty", "section101Xhtml": "",
    "section102Status": "empty", "section102Xhtml": "",
    "section103Status": "empty", "section103Xhtml": ""
  });
  const [initialCalculationNeeded, setInitialCalculationNeeded] = useState(false);

  useImperativeHandle(ref, () => ({
    unsavedChanges: (m11ResearchStudyResource && !jsonEquals(section10State, startingSection10State)),
    async saveAllChanges() {
      await saveStatisticsChanges(dispatch, apiToken, m11ResearchStudyFoi,
        section10State, setAlertModalState, setStartingSection10State);
    }
  }));

  useEffect(() => {
    if (m11ResearchStudyResource?.id) {
      let m11ReportFoi = "";
      if (m11ResearchStudyResource.relatesTo?.length > 0) {
        for (let relatesTo of m11ResearchStudyResource.relatesTo) {
          if (relatesTo.type?.coding?.[0]?.code === "supported-with" && relatesTo.type.text === "M11 Report" &&
            relatesTo.targetReference) {
            m11ReportFoi = getIdFromReference(relatesTo.targetReference);
          }
        }
      }
      if (m11ReportFoi && !isNaN(m11ReportFoi) && m11ReportFoi !== m11ReportContainerFoi) {
        dispatch(m11ReportContainerFoiChanged(m11ReportFoi));
      } else {
        setInitialCalculationNeeded(true);
      }
    }
  }, [m11ResearchStudyResource]);

  useEffect(() => {
    if (initialCalculationNeeded === true) {
      let startingData = {
        "section101Status": "empty", "section101Xhtml": "",
        "section102Status": "empty", "section102Xhtml": "",
        "section103Status": "empty", "section103Xhtml": "",
        "loaded": true
      };
      setSection10State(startingData);
      setStartingSection10State(startingData);
    }
  }, [initialCalculationNeeded]);

  useEffect(() => {
    if (m11ReportContainerFoi && !isNaN(m11ReportContainerFoi)) {
      loadResource(m11ReportContainerFoi, "M11ReportContainer", apiToken, dispatch);
    }
  }, [m11ReportContainerFoi]);

  useEffect(() => {
    if (m11ReportContainerResource && Object.keys(m11ReportContainerResource).length > 0) {
      if (m11ReportContainerResource.section?.[10]?.entry?.length) {
        let m11ReportSection010Foi = getIdFromReference(m11ReportContainerResource.section[10].entry[0]);
        if (m11ReportSection010Foi && !isNaN(m11ReportSection010Foi) && m11ReportSection010Foi !== m11ReportSection10Foi) {
          dispatch(m11ReportSection10FoiChanged(m11ReportSection010Foi));
        } else {
          setInitialCalculationNeeded(true);
        }
      } else {
        setInitialCalculationNeeded(true);
      }
    }
  }, [m11ReportContainerResource]);

  useEffect(() => {
    if (m11ReportSection10Foi && !isNaN(m11ReportSection10Foi)) {
      loadResource(m11ReportSection10Foi, "M11ReportSection10", apiToken, dispatch);
    }
  }, [m11ReportSection10Foi]);

  useEffect(() => {
    if (m11ReportSection10Resource && Object.keys(m11ReportSection10Resource).length > 0) {
      let startingData = {
        "section101Status": "empty", "section101Xhtml": "",
        "section102Status": "empty", "section102Xhtml": "",
        "section103Status": "empty", "section103Xhtml": "",
        "loaded": true
      };
      if (m11ReportSection10Resource.section?.[0]?.section?.length > 0) {
        if (m11ReportSection10Resource.section[0].section[0]?.text?.div &&
          m11ReportSection10Resource.section[0].section[0].text.status !== "empty") {
          startingData.section101Status = m11ReportSection10Resource.section[0].section[0].text.status;
          startingData.section101Xhtml = m11ReportSection10Resource.section[0].section[0].text.div;
        }
        if (m11ReportSection10Resource.section[0].section[1]?.text?.div &&
          m11ReportSection10Resource.section[0].section[1].text.status !== "empty") {
          startingData.section102Status = m11ReportSection10Resource.section[0].section[1].text.status;
          startingData.section102Xhtml = m11ReportSection10Resource.section[0].section[1].text.div;
        }

        if (m11ReportSection10Resource.section[0].section[2]?.text?.div &&
          m11ReportSection10Resource.section[0].section[2].text.status !== "empty") {
          startingData.section103Status = m11ReportSection10Resource.section[0].section[2].text.status;
          startingData.section103Xhtml = m11ReportSection10Resource.section[0].section[2].text.div;
        }
        setSection10State(startingData);
        setStartingSection10State(startingData);
      } else {
        setInitialCalculationNeeded(true);
      }
    }
  }, [m11ReportSection10Resource]);

  return <div>
    <h3>Start Section 10 Statistical Considerations</h3>
        {!(m11ReportSection10Resource?.id || m11ReportContainerResource?.id) &&
            <h1 style={{ color: "red" }}>Please complete Step 5 (Complete Title Page) before filling in M11 Report Section details.</h1>
        }
    {m11User === "sample" ?
      <div style={{ outline: "1px solid #000000", padding: "6px", width: "fit-content" }}>
        <h2>You are using the M11 Report Authoring Tool (Test Drive Version).</h2>
        <p style={{ color: "red" }}>Step 33 (Start Section 10 Statistical Considerations) is not included in the M11 Report Authoring Tool (Test Drive Version).</p>
        <p>Subscribe to the M11 Report Authoring Tool (Professional Version) for complete functionality.</p>
      </div>
      :
      <>
        {section10State.loaded && <>
          <h4 style={{ marginBottom: "0px" }}>Revise the Section 10.1 General Considerations as needed.</h4>
          <TextDivEntry elementName="section101Xhtml"
            startingValue={section10State.section101Xhtml}
            setResourceState={setSection10State} />
          <h4 style={{ marginBottom: "0px" }}>Revise the Section 10.2 Analysis Sets as needed.</h4>
          <TextDivEntry elementName="section102Xhtml"
            startingValue={section10State.section102Xhtml}
            setResourceState={setSection10State} />
          <h4 style={{ marginBottom: "0px" }}>Revise the Section 10.3 Analyses of Demographics and Other Baseline Variables as needed.</h4>
          <TextDivEntry elementName="section103Xhtml"
            startingValue={section10State.section103Xhtml}
            setResourceState={setSection10State} />
        </>}
      </>
    }
  </div >
});

const M11Step033StatisticsPart1HelperText = <div>
  <h3>Start Section 10 Statistical Considerations</h3>
  <div style={{ textAlign: "left" }}>
    <p>Enter data for Section 10.1 General Considerations.</p>
    <div style={{ marginLeft: "24px" }} >
      <p>Provide general statements related to statistical considerations, such as whether a separate statistical analysis plan exists, which summary statistics will be provided, and the timing of analyses (e.g., “The analysis will include all participant data at trial completion”).</p>
    </div>
    <p>Enter data for Section 10.2 Analysis Sets.</p>
    <div style={{ marginLeft: "24px" }} >
      <p>Describe analysis sets to be considered at the trial level, i.e., the set of participants whose data are to be included in the analyses, aligned with estimands. Clearly specify the analysis set to be used for each analysis described in Section 10 Statistical Considerations.</p>
    </div>
    <p>Enter data for Section 10.3 Analyses of Demographics and Other Baseline Variables.</p>
    <div style={{ marginLeft: "24px" }} >
      <p>Describe the summary statistics that will be used to characterise the distribution of demographic and other relevant variables at baseline. Specify when the variables will be measured (e.g., at trial inclusion, prior to randomisation, or at the time of randomisation). Relevant variables include but are not limited to: stratification variables specified in Section 6.7 Investigational Trial Intervention Assignment, Randomisation and Blinding, covariates for the statistical models specified in Section 10.4 Analyses Associated with the Primary Objective(s), other suspected predictive or prognostic variables, and variables used for planned subgroup analyses.</p>
    </div>
    <p>Click the 'Save All Changes' button.</p>
  </div>
</div>

// eslint-disable-next-line no-empty-pattern
const M11Step033StatisticsPart1ValidationCheck = ({ }) => {

  const apiToken = useSelector(selectCurrentUserApiToken);
  const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

  const [validationCheckState, setValidationCheckState] = useState({});

  useEffect(() => {
    if (m11ResearchStudyFoi) {
      validateStep(apiToken, 33, m11ResearchStudyFoi,
        setValidationCheckState)
    }
  }, [m11ResearchStudyFoi]);

  return <div>{validationCheckState?.success && <div>
    <h4>Step 33 (Start Section 10 Statistical Considerations) {validationCheckState.step33numberOfChecks} issues checked. {validationCheckState.step33numberPassed} passed. {validationCheckState.step33numberFailed} failed.</h4>
    <p>Section 10.1 heading is 'General Considerations': {validationCheckState.resultCheckSection101Heading}</p>
    <p>Section 10.1 General Considerations has content: {validationCheckState.resultCheckSection101Content}</p>
    <p>Section 10.2 heading is 'Analysis Sets': {validationCheckState.resultCheckSection102Heading}</p>
    <p>Section 10.2 Analysis Sets has content: {validationCheckState.resultCheckSection102Content}</p>
    <p>Section 10.3 heading is 'Analyses of Demographics and Other Baseline Variables': {validationCheckState.resultCheckSection103Heading}</p>
    <p>Section 10.3 Analyses of Demographics and Other Baseline Variables has content: {validationCheckState.resultCheckSection103Content}</p>
    </div>}  </div>
}

export default M11Step033StatisticsPart1;
export { M11Step033StatisticsPart1HelperText, M11Step033StatisticsPart1ValidationCheck };